<!-- Renders NOTHING while settlement is off: production today, and no operator sees a new step. -->
<div class="cur-choice" *ngIf="asks">
  <div class="cur-label">How is this {{ what }} being settled?</div>
  <div class="cur-opts">
    <button *ngFor="let c of choices" type="button" class="cur-opt"
            [class.is-picked]="isPicked(c)" [class.is-base]="c === base"
            [disabled]="disabled" (click)="pick(c)">
      {{ c }}
    </button>
  </div>
  <div class="cur-hint">
    A charge is booked in the currency it is created in and <strong>cannot be moved later</strong>.
  </div>
</div>

<!-- Already settled: shown as fact, so the operator knows why they were not asked. -->
<div class="cur-settled" *ngIf="showsSettled">
  <i class="bi bi-lock-fill"></i>
  <span>Already settled in <strong>{{ settledCode }}</strong> — this {{ what }} keeps that book.</span>
</div>

<!-- Inherited from an earlier charge on the same record: also a fact, but not the same fact as "already
     settled" — this charge is being settled right now, in the book the record already has. -->
<div class="cur-settled" *ngIf="showsFollows">
  <i class="bi bi-link-45deg"></i>
  <span>This {{ followsWhat }} is settled in <strong>{{ followsCode }}</strong> — this {{ what }} keeps that book.</span>
</div>
